import { isReserveGroupByOption, RESERVE_GROUPBY_ALL, ReserveGroupByKey } from '../../constants';
import { ReserveListOut } from '../../../../store/api';
import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { GroupingState } from '../../../../store/grouping/state';

export type ApiReserveReportsParams = {
    financialYear: string | number;
    grouping?: GroupingState;
};

export const fetchReserveReports = ({ financialYear, grouping }: ApiReserveReportsParams) => {
    const params = { financialYear };
    const groupBy = grouping?.key;

    if (groupBy && groupBy !== RESERVE_GROUPBY_ALL && isReserveGroupByOption(groupBy as ReserveGroupByKey)) {
        params['status'] = groupBy;
    }

    return http.get<ReserveListOut[]>(reservesConfig().endpointReserveListOverview, { params }).then(res => res.data);
};
